<template>

    <custom-dialog
      class="factory-aftersale-dialog"
      width="1000px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body ubv">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <!-- 搜索栏 -->
            <el-form-item style="float: right">
              <search-input
                :placeholder="$t('asm_factory_aftersale_dialog.shou_hou_gong_si')"
                v-model="formSearch.afterServiceName"
                @fetch="onPageChange({ page: 1 })"
              ></search-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-bd">
          <custom-table
            v-model="tableSelect"
            type="checkbox"
            :column="tableColumn"
            :data="tableList"
            @filter="filterChange"
            @sort="sortChange"
            height="500px"
          >
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page
            :total="totalRows"
            :page="formSearch.pageNum"
            :size="formSearch.pageSize"
            @change="onPageChange"
          ></custom-page>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $t('Common.com_cancel')
        }}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{
          $t('Common.com_confirm')
        }}</el-button>
      </div>
    </custom-dialog>

</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'factory_aftersale_bind',
      visible: false,
      formSearch: {
        userId: '',
        afterServiceName: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        isAssociate: 0 // 未关联
      },
      tableList: [],
      totalRows: 0
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.getTableList();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.userId = this.model.data.userId;
      this.$getJSON(apis.userAreaUnAssScPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },

    // 确认保存
    confirm: function () {
      const params = {
        serviceList: this.tableSelect,
        userId: this.model.data.userId,
        userName: this.model.data.userName
      };
      this.$postJSON(apis.UserAreaBatchSave, params).then(() => {
        this.$message({
          message: this.$t('Common.com_save_success'),
          type: 'success'
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  }
};
</script>

<style lang="scss">
.factory-aftersale-dialog {
}
</style>
